export default "__VITE_ASSET__yEl_G_Zr__"